// Приблизительные центры областей Кыргызстана.
// Синхронизировано с server/src/utils/regionByCoords.js — для автоопределения
// region_id по координатам (клиентский пресет для UI формы).
const REGION_CENTERS: Record<string, { lat: number; lng: number }> = {
  bishkek:    { lat: 42.87, lng: 74.59 },
  chuy:       { lat: 42.77, lng: 74.95 },
  issyk_kul:  { lat: 42.65, lng: 77.08 },
  naryn:      { lat: 41.42, lng: 75.99 },
  talas:      { lat: 42.52, lng: 72.24 },
  jalal_abad: { lat: 41.09, lng: 72.99 },
  osh:        { lat: 40.53, lng: 72.80 },
  batken:     { lat: 40.06, lng: 70.82 }
}

/** Возвращает code ближайшей области к точке (lat, lng). null если координаты невалидны. */
export function findRegionCodeByCoords(lat: number | string, lng: number | string): string | null {
  const flat = Number(lat)
  const flng = Number(lng)
  if (!Number.isFinite(flat) || !Number.isFinite(flng)) return null

  let bestCode: string | null = null
  let bestDist = Infinity
  for (const [code, c] of Object.entries(REGION_CENTERS)) {
    const dLat = c.lat - flat
    const dLng = c.lng - flng
    const d = dLat * dLat + dLng * dLng
    if (d < bestDist) {
      bestDist = d
      bestCode = code
    }
  }
  return bestCode
}
